import { hudModules, hudPaths, HudPath, toHudHash } from '../content';
import { HudPanel, SystemButton, SystemFrame } from '../primitives';

export const PageActionBar = ({ activePath, ctaLabel }: { activePath: HudPath; ctaLabel: string }) => {
  const quickLinks = hudModules
    .filter((module) => module.path !== activePath && module.path !== hudPaths.home)
    .slice(0, 3);

  return (
    <SystemFrame id="page-actions" className="min-h-0 pb-10 pt-4">
      <HudPanel pulse className="bg-brand-panel-2/74">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <p className="hud-micro text-brand-aqua">COMMAND ACTIONS</p>
          <div className="flex flex-wrap items-center gap-2">
            <SystemButton href={toHudHash(hudPaths.home)} variant="secondary">
              Return To Start Panel
            </SystemButton>
            <SystemButton href={toHudHash(hudPaths.communicationsTerminal)}>{ctaLabel}</SystemButton>
          </div>
        </div>

        <div className="mt-4 flex flex-wrap gap-2">
          {quickLinks.map((module) => (
            <a
              key={module.id}
              href={toHudHash(module.path)}
              className="hud-nav-link border-brand-lime/30 bg-brand-panel/60 text-[0.56rem]"
            >
              {module.shortLabel}
            </a>
          ))}
        </div>
      </HudPanel>
    </SystemFrame>
  );
};
